import { P2GBox, P2GDate, SvgConfirmCircle, P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { BookingDetails } from '~/lib/api/smartsend/types';
import { ExtendedOrderCache } from '../../../lib/cache/ExtendedOrderCache';
import AlertWithIcon from '../../AlertWithIcon';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';

interface props {
  bookingDetails: BookingDetails;
}

export default function ItemRefunds(props: props) {
  const refunds = useMemo(() => {
    return ExtendedOrderCache.refundOrderLineIds.filter((x) => x.orderlineId === props.bookingDetails?.OrderLineId);
  }, [props.bookingDetails]);

  if (!props.bookingDetails || !props.bookingDetails?.OrderLineId || refunds.length === 0) {
    return null;
  }

  return (
    <P2GBox>
      {refunds.map((r) => (
        <AlertWithIcon
          icon={<SvgConfirmCircle />}
          iconSrc="/theme/icons/ConfirmCircle.svg"
          color="success"
          key={r.orderlineId}
        >
          <P2GText component="p">
            <strong>{r.status}</strong>
          </P2GText>
          <P2GText component="p" small>
            <i>
              Created <P2GDate small date={r.created} size="medium" /> for{' '}
              {toDisplayCurrency(props.bookingDetails.FinancialSummary?.CurrencyCode, r.amount)}
            </i>
          </P2GText>
        </AlertWithIcon>
      ))}
    </P2GBox>
  );
}
